var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoublebrested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st59{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n\t.st58{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st57{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M274.12,74.54c-5.49,36.15-14.35,65.13-21.92,85.72c-16.01,43.63-29.26,57.89-39.19,64.78 c-9.93-6.87-23.18-21.13-39.21-64.78c-7.42-20.19-16.08-48.44-21.6-83.61c16.03,5.41,36.19,8.64,58.06,8.64 C234.86,85.29,257.28,81.21,274.12,74.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M274.12,87.54c-5.49,36.15-14.35,65.13-21.92,85.72c-16.01,43.63-29.26,57.89-39.19,64.78 c-9.93-6.87-23.18-21.13-39.21-64.78c-7.42-20.19-16.08-48.44-21.6-83.61c16.03,5.41,36.19,8.64,58.06,8.64 C234.86,98.29,257.28,94.21,274.12,87.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M108.21,228.52l4.32,1.98c4.55-6.09,1.53-9.79,2.7-22.15c0.85-8.94-1.22-19.75-1.86-22.61 c-3.79-17.26-6.23-48.26-12.53-93.68l-0.31,0.03l7.68,102.19V228.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M113.37,185.74c0.64,2.86,2.71,13.66,1.86,22.61c-1.17,12.36-4.94,19.4-9.49,25.49 c-1.1,1.5-2.26,2.95-3.44,4.4c4.36,11.76,9.69,29.64,11.07,51.83c0.96,15.2-0.33,26.06-1.77,39.87 c-1.93,18.53-4.45,45.62-6.64,80.18c25.69,11.96,51.39,23.92,77.08,35.88c5-7.11,14.66-18.89,30.57-28.35 c14.26-8.48,27.6-11.58,35.88-12.85c-0.29-55.82-0.58-111.64-0.89-167.45c-8.36-0.7-20.56-2.91-32.77-10.18 c-10.21-6.07-24.64-18.18-42.53-66.9c-7.67-20.88-16.68-50.4-22.15-87.26c-16.09,6.19-33.52,10.63-49.61,16.83 c0.11,0.74,0.21,1.49,0.31,2.23C107.14,137.48,109.58,168.48,113.37,185.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M314.79,228.52l-2.26-4.02c-4.55-6.09-3.59-3.79-4.76-16.15c-0.85-8.94,1.22-19.75,1.86-22.61 c3.79-17.26,6.23-48.26,12.53-93.68l0.31,0.03l-7.68,102.19V228.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M309.63,186.74c-0.64,2.86-2.71,13.66-1.86,22.61c1.17,12.36,4.94,19.4,9.49,25.49c1.1,1.5,2.26,2.95,3.44,4.4 c-4.36,11.76-9.69,29.64-11.07,51.83c-0.96,15.2,0.33,26.06,1.77,39.87c1.93,18.53,4.45,45.62,6.64,80.18 c-25.69,11.96-51.39,23.92-77.08,35.88c-5-7.11-14.66-18.89-30.57-28.35c-14.26-8.48-27.6-11.58-35.88-12.85 c0.29-55.82,0.58-111.64,0.89-167.45c8.36-0.7,20.56-2.91,32.77-10.18c10.21-6.07,24.64-18.18,42.53-66.9 c7.67-20.88,16.68-50.4,22.15-87.26c16.09,6.19,33.52,10.63,49.61,16.83c-0.11,0.74-0.21,1.49-0.31,2.23 C315.86,138.48,313.42,169.48,309.63,186.74z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st59",
    x1: 210.27,
    y1: 98.29,
    x2: 211.82,
    y2: 224
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 107.98,
    y: 357.59,
    className: "st59",
    width: 53.16,
    height: 4.13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.08,
    y: 357.59,
    className: "st59",
    width: 53.16,
    height: 4.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st59",
    x1: 143.42,
    y1: 279.91,
    x2: 145.19,
    y2: 355.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st59",
    x1: 278.18,
    y1: 281.98,
    x2: 276.4,
    y2: 357.59
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 187.53,
    cy: 251.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 188.53,
    cy: 322,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 187.53,
    cy: 392.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 239.53,
    cy: 251.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 240.53,
    cy: 322,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st57",
    cx: 239.53,
    cy: 392.5,
    r: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublebrested);
export default __webpack_public_path__ + "static/media/DOUBLE BRESTED.819c3e98282c8d58ca32145b089ef997.svg";
export { ForwardRef as ReactComponent };